import React, { FC, useCallback, useState } from 'react';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';
import RanksTable from 'buyside/components/presentation/RankingsIndexPage/currentUserRankInfo/RanksTable';

import { useCurrentUserRankHistoryQuery } from 'interfaces/graphql-typings';

const CurrentUserRankHistoryModal: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, error, loading } = useCurrentUserRankHistoryQuery();

  const ranks = data?.currentUser?.ranks;

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        onClick={() => setIsModalOpen(true)}
        size={BUTTON_SIZES.SMALL}
        text="Click to View Your Rankings History"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  if (loading || !ranks?.length) return null;

  if (error) throw error;

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title="Your Rankings History"
    >
      <RanksTable ranks={ranks} />
    </Modal>
  );
};

export default CurrentUserRankHistoryModal;
